"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var debounce_1 = require("debounce");
exports.default = vue_1.default.extend({
    props: ["groupe"],
    data: function () {
        return {
            textToSearch: "",
            affairesFiltered: this.groupe.affaireTaches
        };
    },
    methods: {
        search: debounce_1.debounce(function (val) {
            if (val == "" || val.length < 3) {
                this.affairesFiltered = this.groupe.affaireTaches;
                return;
            }
            this.affairesFiltered = this.groupe.affaireTaches.filter(function (_) {
                return _.codeAffaire != null && _.codeAffaire.includes(val) ||
                    _.codeEnedis != null && _.codeEnedis.includes(val) ||
                    _.libelle != null && _.libelle.includes(val) ||
                    _.statut != null && _.statut.includes(val) ||
                    _.commune != null && _.commune.includes(val) ||
                    _.type != null && _.type.includes(val) ||
                    _.numBonCommande != null && _.numBonCommande.includes(val);
            });
        }, 300),
        getTaskUrl: function (idAffaire, idTask, idBc) {
            return "/Affaires/" + idAffaire + "/ExecuteTask/" + idTask + "?bonCommandeId=" + idBc;
        },
        loadAffaire: function (idAffaire) {
            var url = "/Affaires/Detail/" + idAffaire;
            window.open(url, "_blank");
        }
    },
    watch: {
        textToSearch: function (val) {
            this.search(val);
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Dashboard/Components/DashboardTableauAffaires.vue
// module id = 177
// module chunks = 0